import { forwardRef, type LabelHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export type LabelProps = LabelHTMLAttributes<HTMLLabelElement> & {
  required?: boolean;
  disabled?: boolean;
};

export const Label = forwardRef<HTMLLabelElement, LabelProps>(({ className, children, required, disabled, ...props }, ref) => (
  <label ref={ref} className={cn("bfrs-text-xs bfrs-font-semibold bfrs-leading-none bfrs-text-text-primary", disabled && "bfrs-text-text-disabled", className)} {...props}>
    {children}
    {required && <span className="bfrs-ml-1 bfrs-text-danger" aria-hidden="true">*</span>}
  </label>
));

Label.displayName = "Label";
